import { gql } from '@apollo/client/core';

const CurrentUserUnseenNotificationsQuery = gql`
  query currentUser($platform: Platform) {
    currentUser {
      id
      unreadConnectionRequestsCount
      unseenWarRoomNotifications(platform: $platform)
      unreadWarRoomNotifications(platform: $platform)
    }
  }
`;

export default CurrentUserUnseenNotificationsQuery;
